import { Directive } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { GetUserCountryIpService } from '../services/get-user-country-ip.service';
import { whiteListIpAddressList } from '../helpers/whitelistedIP';
import { GetIpstackService } from '../services/get-ipstack.service';
@Directive({
  selector: '[appGetCountryIp]'
})
export class GetCountryIpDirective {

  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService, private getIp: GetUserCountryIpService, private getIPstack: GetIpstackService) {
    this.getRootScopeData();
    this.getCountryCode();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }
  getCountryCode() {
    let callIPStackFlag = false;
    let matchedIP = false;
    this.getIp.getCountryIP()
      .subscribe(
        data => {
          if (data === null) { data = { country_code: 'SG', ip: '203.116.100.120' }; }
          const countryCode = data.country_code.toLowerCase();
          // tslint:disable-next-line: only-arrow-functions
          whiteListIpAddressList.forEach(function(element) {
            if (data.ip === element.ip) {
              callIPStackFlag = false;
              matchedIP = true;
            } else {
              callIPStackFlag = true;

            }
          });
          if (matchedIP === true) {
            this.setuserAccessingCountryCodeInLocalStorage(countryCode);
          } else {
            this.callIpStack();
            // this.setuserAccessingCountryCodeInLocalStorage(countryCode);
          }

        },
        error => {
          console.error('API failed.');
          this.callIpStack();
          // this.setuserAccessingCountryCodeInLocalStorage('sg');
        }
      );
  }
  callIpStack() {
    this.getIPstack.getIPstackService()
      .subscribe(
        data => {
          if (data.country_code) {
            this.setuserAccessingCountryCodeInLocalStorage(data.country_code.toLowerCase());
          } else {
            this.findTronCountries();
          }

        }, error => {
          console.error('API failed.');
          this.findTronCountries();
        }
      );

  }
  setuserAccessingCountryCodeInLocalStorage(countryCode: string) {
    this.rootScopeData.userAccessingCountryCode = countryCode;
    if (localStorage.getItem('loggedInCountryCode') != null) {
      localStorage.removeItem('loggedInCountryCode');
    }
    localStorage.setItem('loggedInCountryCode', this.rootScopeData.userAccessingCountryCode);
    this.findTronCountries();
    if (this.rootScopeData.userAccessingCountryCode === 'us') {
      this.rootScopeData.isIpUsbased = true;
    } else { this.rootScopeData.isIpUsbased = false; }

  }
  findTronCountries() {

    // US=> United States, GB=>United Kingdom, DE=>Germany, be=>belgium, nl=>netherlands, es=>Spain, hk=>hongkong, au=>australia
    if (this.rootScopeData.userAccessingCountryCode === 'us' ||
      this.rootScopeData.userAccessingCountryCode === 'gb' ||
      this.rootScopeData.userAccessingCountryCode === 'de' ||
      this.rootScopeData.userAccessingCountryCode === 'be' ||
      this.rootScopeData.userAccessingCountryCode === 'nl' ||
      this.rootScopeData.userAccessingCountryCode === 'es' ||
      this.rootScopeData.userAccessingCountryCode === 'hk' ||
      this.rootScopeData.userAccessingCountryCode === 'au') {
      this.rootScopeData.isTronCountry = true;
    } else {
      this.rootScopeData.isTronCountry = false;
    }

  }
}
